import {atom, useAtomValue, useSetAtom} from 'jotai/index';

import {AppType} from '@web-catalog/types';

export const headerAppTypeAtom = atom<AppType | null>(null);

export const useHeaderAppTypeValue = () => useAtomValue(headerAppTypeAtom);

export const useSetHeaderAppType = () => useSetAtom(headerAppTypeAtom);
